module.exports = __webpack_public_path__ + "static/img/6.9701761.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/1/sp/6.png
// module id = gR1Z
// module chunks = 0